module.exports = __webpack_public_path__ + "img/AB2D08_C35E5A_C75522_C56C70-256px.d8af334b.png";